module.exports = __webpack_public_path__ + "b1a0c4f2535823df4451d15f3ab678f6.svg";